import React from 'react'
// import bzquickLoading from "assets/bzquickloading.gif"
import { useSelector } from "react-redux";


export default function Loading(props) {
  const { styles } = useSelector((state) => state);

  return (
    <>
    <div
      className="loading d-flex  flex-column align-items-center position-fixed "
      style={{ zIndex: 100 }}
    >
      <div className={`spinner-border ${styles?.priColor} me-2`} role="status"></div>
      {/* <img style={{width:"50px"}} src={bzquickLoading}  alt="loading..." /> */}
      <div className={` ${styles?.priColor}`}>{props.text}</div>
    </div>
    <div
      className={`${styles?.bg} position-fixed top-0 start-0 w-100 h-100 `}
      style={{ zIndex: 99, opacity: "60%" }}
    />
  </>
  )
}